enum ErrorMessage {
  FILE_NAME_VALIDATION_ERROR = "'fileName' failed to satisfy constraint: Member must satisfy regular expression pattern:"
}

export default ErrorMessage
